import React from 'react';
import * as Auth from '../../domains/AuthDomain';
import { getURLVal } from '../../domains/URLDomain';
import config from 'config';
import ReactGA from 'react-ga';
import standardizeEmail from '../../common/standardizeEmail';
import ReactPixel from 'react-facebook-pixel';
import pixelIds from '../../api/fbPixelConfig';
import Immutable from 'immutable'
import { FetchOneTimeCoupon } from '../../domains/PaymentDomain';//temp
import { FetchModernSlug } from '../../api/payment.api';

const SHOW_GDPR = false; //turn to true once ready to deploy
const EMAIL_CONSENT_PROMPT = 'Yes, I would like to receive emails from my coaches for workout tips, new programs, updates and offers.';


class CoachCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlanIdx: null,
      isAuthed: false,
      userId: '',
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      emailConsent: false,
      showSignup: false,
      showLogin: false,
      activeSection: 0, //values are 0-2
      validationErrors: {},
      emailError: false,
      pwError: false,
      loginErrorDesc: '',
      loginError: false,
      authLoading: false,
      coachOrgId: props.route.coachOrgId,
      extraPlan: props.route.extraPlan,
      paymentLoading: false,
      paymentError: '',
      benefitsShowing: false,
      shouldSkipAuth: this.shouldSkipAuth(),
      shouldSurvey: false,
      isAwaitingPaidConf: null,
      hasUserPaid: false,
      paymentErr: null,
      agreementsChecked: true,
      primarySurveyResponse: false,
      surveyStep: 1,
      subgoals: {},
      showEnterPromo: false,
      couponCode: '',
      appliedCouponCode: '',
      isUserInputCouponValid: null,
      showPayPalHint:false,
      oneTimeCouponPlan: null,//temp
      isCheckingRedirect: true,
    };

    this.paymentErrors = {
      noPlanSelected: 'Please select a plan on Step 1',
      notAuthed: 'Please sign up or log in on Step 2'
    };
  }

  componentDidMount = async () => {
    if(!this.props.route.extraPlan){
      try {
        const modernSlug = await FetchModernSlug(this.state.coachOrgId);
        if (modernSlug) {
          //Redirect to my.trybe.fit
          const newURL = `https://my.trybe.fit/${modernSlug}/checkout${window.location.search}`;
          window.location.replace(newURL);
          return;
        }
      } catch (e) {
        console.error('Error fetching modern slug for redirect:', e);
      }
    }

    this.setState({ isCheckingRedirect: false });

    this.props.actions.paymentActions.fetchProductInfo(this.state.coachOrgId);
    this.props.actions.paymentActions.fetchOnboardingOptions(this.state.coachOrgId);

    if(this.props.route.tabTitle) {
      document.title = this.props.route.tabTitle;
    }

    if(pixelIds[this.props.route.coachOrgId]){
      const pixelId = pixelIds[this.props.route.coachOrgId];
      ReactPixel.init(pixelId);
      ReactPixel.pageView();
    }

    this.initAnalytics();
  };

  initAnalytics = async () => {
    const { coachOrgId } = this.state;

    let coachName = this.props.coachName;
    if(!coachName){
      coachName = await this.props.actions.analyticsActions.fetchCoachName(coachOrgId);
    }

    if(this.props.onboardingGoalOptions.length > 0){

      const { shouldSurvey } = this.shouldSurvey(coachOrgId);
      this.setState({shouldSurvey});
    }
  }

  shouldSurvey = (coachOrgId) => {

    //Include in survey analysis if coachOrgId is in list. Used to determine proper denominator of sample
    const validCoachOrgIds = ['-MW2M4tJakuYczP6HfZa', '-LT477BU7OW8AglPgFlg'];
    const coachOrgIdValid = validCoachOrgIds.includes(coachOrgId);

    const prob = 0.4 //% chance to serve survey. 0.4 = 40% chance
    const shouldSurvey =  coachOrgIdValid ? Math.random() <= prob : false;

    return { shouldSurvey, includeInSurveyTestSample: coachOrgIdValid }
  }

  renderSurvey = () => {
    const isForSurvey = true

    return (
      <div className='survey-container'>
        <div className='survey-inner-container'>
          { this.renderLogo(isForSurvey) }
          { this.renderSurveyPage() }
          <div className='survey-bottom-nav'>
            {this.state.surveyStep > 1 ? this.renderSurveyBack() : null}

            {this.state.surveyStep >= 3 ? null : <div className='skip-text' onClick={this.onPressSkip}>{`Skip for now >>`}</div>}
          </div>

          <div className='survey-bottom-nav'>
            <div className='have-account' onClick={this.onPressHaveAccount}>{`Already have an account?`}</div>
          </div>
        </div>
      </div>
    )
  }

  renderSurveyPage = () => {
    const { surveyStep } = this.state;

    if(surveyStep === 1 ) {
      return this.renderPrimaryGoals();
    } else if (surveyStep === 2) {
      return this.renderSubGoals();
    } else {
      return this.renderSurveyComplete();
    }
  }

  renderPrimaryGoals = () => {
    const headerQuestion = 'What would you like to do?'
    const { onboardingGoalOptions } = this.props;
    const options = onboardingGoalOptions.map((val, idx) => {
      const { mainText, secondaryText, defaultPrimaryProgramId, defaultPrimaryProgramName, subgoals, primaryProgramImage } = val;
      const option = this.renderSurveyOption({mainText, secondaryText, programId: defaultPrimaryProgramId, subgoals, programName: defaultPrimaryProgramName, surveyStep: 1, previewImg: primaryProgramImage});
      return option;
    })

    return(
      <div className='survey-page'>
        <div className='survey-header'>
          <div className='survey-header-text'>
            {headerQuestion}
          </div>
          </div>
        <div className='survey-options-container'>
          { options }
        </div>
      </div>
    )
  }

  renderSurveyBack = () => {
    return (
      <div className='survey-back'onClick={this.onPressBack}>
        {`<`}
      </div>
    )
  }

  renderSubGoals = () => {
    const { subgoals } = this.state;
    const { subGoalOptions, subGoalsHeader } = subgoals;
    const headerQuestion = subGoalsHeader || `Select an initial program`

    const options = subGoalOptions.map((val, idx) => {
      const { description, primaryProgramId, primaryProgramName, primaryProgramImage, programIsPaid, title} = val;
      const option = this.renderSurveyOption({mainText: title, secondaryText: description, programId: primaryProgramId, programName: primaryProgramName, surveyStep: 2, previewImg: primaryProgramImage});
      return option;
    })

    return(
      <div className='survey-page'>
        <div className='survey-header'>
         <div className='survey-header-text'> {headerQuestion}</div>
          </div>
        <div className='survey-options-container'>
          { options }
        </div>
      </div>
    )
  }

  renderSurveyComplete = () => {
    const mainHeader = `Great! We'll customize your program selection based on your responses.`
    const subHeader = `Complete checkout then download the app to get started training!`
    return (
      <div className='survey-page'>
        <div className='survey-header'>
          <div className='survey-header-text'>
            {mainHeader}
          </div>
        </div>
        <div className='survey-sub-header'>{subHeader}</div>
        <div className='buttons-container'>
          <div onClick={this.onPressContinue} className ='survey-button'><span>Continue</span></div>
        </div>
      </div>
    )
  }

  onPressBack = () => {
    const { surveyStep } = this.state;

    if( surveyStep > 1) {
      this.setState({surveyStep: surveyStep - 1})
    }
  }

  onPressContinue = () => {
    this.setState({shouldSurvey: false})
  }

  onPressSkip = () => {
    this.setState({shouldSurvey: false})
  }

  onPressHaveAccount = () => {
    this.setState({shouldSurvey: false})
  }

  renderSurveyOption = ({mainText, secondaryText, programId, programName, subgoals = false, surveyStep = 1, previewImg}) => {
    return (
      <div className='survey-option' onClick={() => {this.setSurveyResponse({surveyStep, programId, subgoals, previewImg, programName})}}>
        <div className='survey-text-container'>
          <div className='main-text'>{mainText}</div>
          <div className='secondary-text'>{secondaryText}</div>
        </div>
      </div>
    )
  }

  setSurveyResponse = ({surveyStep = 1, programId, subgoals, previewImg, programName}) => {
    const primarySurveyResponse = {
      programId,
      previewImg,
      nextDayIdx: 0,
      name: programName,
    }
    if(surveyStep === 1) {
      if(subgoals) {
        this.setState({primarySurveyResponse, subgoals, surveyStep: 2 });
      } else {
        this.setState({primarySurveyResponse, surveyStep: 3 });
      }
    } else if (surveyStep === 2 ) {
      this.setState({primarySurveyResponse, surveyStep: 3})
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.route.extraPlan && nextProps.extraPlanOptions && nextProps.extraPlanOptions !== this.props.extraPlanOptions && nextProps.extraPlanOptions.get(this.props.route.extraPlan)){
      if(nextProps.extraPlanOptions.get(nextProps.route.extraPlan).size < 2){
        this.setState({ selectedPlanIdx: 0 }, this.calculateActiveSection)
      }
    } else {
      if(nextProps.planOptions !== this.props.planOptions && nextProps.planOptions.size < 2) {
        this.setState({ selectedPlanIdx: 0 }, this.calculateActiveSection)
      }
    }

    if(nextProps.siteCheckout) {
      const benefitsShowing = (nextProps.siteCheckout.get('benefits') && nextProps.siteCheckout.get('benefits').size > 0)
      this.setState({ benefitsShowing })
    }
  }

  shouldSkipAuth = () => {
    const uid = getURLVal('uid');
    const source = getURLVal('source');
    const email = getURLVal('email');

    if(uid && email && source === 'app') {
      return true;
    } else {
      return false;
    }
  }

  getPriceDisplay = (price) => {
    const hasCents = price % 100;
    const renderPrice = price / 100;
    const with2Decs = renderPrice.toFixed(2);
    return hasCents ? with2Decs : renderPrice;
  }

  calculateActiveSection = () => {
    if(!(this.state.selectedPlanIdx || this.state.selectedPlanIdx === 0)) {
      this.setState({ activeSection: 0 });
    } else if(!this.state.isAuthed) {
      this.setState({ activeSection: 1 });
    } else {
      this.setState({ activeSection: 2 });
    }
  };

  getGAPlanLabel = (planIdx) => {
    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions && this.props.extraPlanOptions.get(this.props.route.extraPlan)){
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }

    if(!planOptions) {
      return null;
    }

    const planSelected = planOptions.get(planIdx);
    if(!planSelected) {
      return null;
    }

    const planJS = planSelected.toJS();
    const { time_unit, time_val, price } = planJS;

    let label = null;
    if(time_unit && time_val) {
      label = `${time_val}_${time_unit}`;
    } else {
      label = this.getPriceDisplay(price);
    }

    label += '_coachOrgId=' + this.state.coachOrgId;

    return label;
  }

  getPriceLabel = (planIdx) => {
    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions && this.props.extraPlanOptions.get(this.props.route.extraPlan)){
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }

    if(!planOptions) {
      return null;
    }

    const planSelected = planOptions.get(planIdx);
    if(!planSelected) {
      return null;
    }

    const planJS = planSelected.toJS();
    const { price } = planJS;

    let label = null;

    if(price){
      label = price;
    }

    return label;
  }

  //BUTTON FUNCTIONS
  selectPlan = planIdx => {
    this.setState({ selectedPlanIdx: planIdx }, () => {
      this.calculateActiveSection();
    });

    if(this.state.paymentError === this.paymentErrors.noPlanSelected) {
      this.setState({
        paymentError: ''
      });
    }

    const label = this.getGAPlanLabel(planIdx);

    ReactGA.event({
      category: 'Purchase',
      action: 'Selected Plan',
      label
    });
  };

  onClickLogin = async () => {
    this.setState({ authLoading: true });

    const { password } = this.state;
    let { email } = this.state;

    email = standardizeEmail(email);

    const {
      accessToken,
      error,
      error_description
    } = await Auth.getAccessToken({ email, password });

    if(accessToken) {
      const { userId } = await Auth.getUserInfo(accessToken);

      this.setState({
        isAuthed: true,
        loginError: false,
        paymentError: '',
        userId,
        authLoading: false
      }, () => {
        this.calculateActiveSection();
      });

      ReactGA.set({ userId });

      ReactGA.event({
        category: 'User',
        action: 'Logged in'
      });

      await Auth.dbAuth(userId);

      if(this.state.paymentError === this.paymentErrors.notAuthed) {
        this.setState({
          paymentError: ''
        });
      }
    } else if(error) {
      this.setState({
        loginErrorDesc: error_description,
        loginError: true,
        authLoading: false
      });
    }
  }

  onClickSignup = async () => {
    const { password, firstName, lastName, emailConsent, coachOrgId, primarySurveyResponse } = this.state;
    let { email } = this.state;

    email = standardizeEmail(email);

    this.setState({
      loginErrorDesc: '', //Wipes out prior login attempt error message as validation may stop Auth.signup from running
      authLoading: true
    });

    const emailValid = Auth.checkEmailValid(email);
    this.setState({ emailError: !emailValid });

    const pwValid = Auth.checkPwValid(password);
    this.setState({ pwError: !pwValid });

    if(!emailValid || !pwValid) {
      this.setState({
        authLoading: false
      });

      return;
    }

    const { userId, error } = await Auth.signup({
      email,
      password,
      firstName,
      lastName
    });

    if(error) {
      this.setState({
        loginErrorDesc: error,
        loginError: true,
        authLoading: false
      });
    } else if(userId) {
      const auth = await Auth.dbAuth(userId);

      if(!auth) {
        console.log('Auth failed');
        return;
      }

      await this.props.actions.signUpActions.initUserAcct({
        userId,
        email,
        firstname: firstName,
        lastname: lastName,
        coachOrgId: coachOrgId,
        emailConsent: emailConsent,
        emailConsentPrompt: EMAIL_CONSENT_PROMPT,
        waiverConsent: true,
        primarySurveyResponse,
      });

      this.setState({
        isAuthed: true,
        loginError: false,
        paymentError: '',
        userId,
        authLoading: false
      }, () => {
        this.calculateActiveSection();
      });


      if(this.state.paymentError === this.paymentErrors.notAuthed) {
        this.setState({
          paymentError: ''
        })
      }

      ReactGA.set({ userId });

      ReactGA.event({
        category: 'User',
        action: 'Signed up'
      });
    }
  }

  prepInitStripeCheckoutArgs = () => {
    const { selectedPlanIdx, paymentError } = this.state;

    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions && this.props.extraPlanOptions.get(this.props.route.extraPlan)){
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }
    const planSelected = planOptions.get(selectedPlanIdx);

    let stripeCouponId = null;
    let discountedPrice = null;
    const minuteBuffer = 60;
    const unixBuffer = minuteBuffer * 60 * 1000 //Minutes X 60 seconds x 1000 milliseconds
    const activePromo = this.findValidPromoOfPlan(planSelected, unixBuffer);//adds buffer to expiration date so people who take a while to checkout dont lose the promo when clicking pay
    if(activePromo) {
      stripeCouponId = activePromo.get('stripeCouponId');
      discountedPrice = activePromo.get('buttonPrice');
    }

    let initStripeCheckoutArgs = {
      planSelected: planSelected.toJS(),
      stripeCouponId,
      coachOrgStripePubKey: this.props.stripePubKey,
      coachOrgId: this.state.coachOrgId,
      successURL: this.getCheckoutSuccessUrl(planSelected.get('price'), discountedPrice),
      discountedPrice
    }

    const TRIAL_CLAIMED_ERR = 'Trial has already been claimed. Proceed without a trial?'
    if(paymentError === TRIAL_CLAIMED_ERR){
      //if user has already claimed trial, received TRIAL_CLAIMED_ERR, and clicked pay again,
      //then pass userConfirmedWaiveTrial
      initStripeCheckoutArgs.userConfirmedWaiveTrial = true
    }

    if(this.props.route.requireBillingAddress){
      initStripeCheckoutArgs.requireBillingAddress = true;
    }

    if(this.props.route.enableRewardful){
      const rewardfulId = getURLVal('refid')
      initStripeCheckoutArgs.rewardfulId = rewardfulId
    }

    if(this.state.shouldSkipAuth) {
      initStripeCheckoutArgs = Object.assign(initStripeCheckoutArgs, {
        mobileRequestId: getURLVal('uid') //if user came from mobile app, data is pre-stored in db
      })
    } else {
      initStripeCheckoutArgs = Object.assign(initStripeCheckoutArgs, {
        userId: this.state.userId,
        firstname: this.state.firstName,
        lastname: this.state.lastName,
        email: standardizeEmail(this.state.email)
      });
    }

    //ap stands for ad payer
    if(getURLVal('ap') === 'trybe'){
      initStripeCheckoutArgs.ap = 'trybe'
    }

    return initStripeCheckoutArgs;
  }


  onClickPay = () => {
    const {
      isAuthed,
      shouldSkipAuth,
      selectedPlanIdx,
    } = this.state;

    if (!selectedPlanIdx && selectedPlanIdx !== 0) {
      this.setState({
        paymentError: this.paymentErrors.noPlanSelected
      })
    } else if (!isAuthed && !shouldSkipAuth){
      this.setState({
        paymentError: this.paymentErrors.notAuthed
      })
    } else {
      this.handlePayment();
    }
  }

  handlePayment = async () => {
    this.setState({ paymentLoading: true });

    const initStripeCheckoutArgs = this.prepInitStripeCheckoutArgs();

    const { success, error } = await this.props.actions.paymentActions.initStripeCheckout(initStripeCheckoutArgs);

    if(success) {
      window.location = success; //success val is Stripe Checkout seshion link
    } else {
      this.setState({
        paymentLoading: false,
        paymentError: error
      });
    }

    const { selectedPlanIdx } = this.state;

    ReactGA.event({
      category: 'Purchase',
      action: 'Clicked Pay',
      label: this.getGAPlanLabel(selectedPlanIdx)
    });

    if(pixelIds[this.props.route.coachOrgId]){
      const pixelId = pixelIds[this.props.route.coachOrgId];
      ReactPixel.trackSingle(pixelId, 'InitiateCheckout');
    }
  }

  onClickAgreementsCheck = () => {
    this.setState({
      agreementsChecked: !this.state.agreementsChecked
    });
  }

  onClickApp = () => {
    if(this.props.siteCheckout && this.props.siteCheckout.get('deepLink')) {
      window.open(
        this.props.siteCheckout.get('deepLink'),
        '_blank'
      )
    }
  }

  //RENDER FUNCTIONS
  renderLogo = (isForSurvey) => {
    if(isForSurvey){
      return (
        <div className='survey-logo-container'>
          <img className='survey-logo-img' src={this.props.logo} />
        </div>
      )
    }

    return (
      <div className='creator-logo-container'>
        <img className='logo-img' src={this.props.logo} />
      </div>
    );
  };

  renderHighlightBadge = (text, color) => {
    if(!text) return null;

    const defaultColor = '#30cd9a';
    const badgeColor = color || defaultColor;

    return (
      <div className='highlight-badge' style={{backgroundColor: badgeColor}}>
        <div className='badge-text'>{text}</div>
      </div>
    );
  }

  renderPlanTopLargePromo = (plan) => {
    const origPrice = plan.get('price');
    const currency = plan.get('currency') || 'USD';
    const promoText = this.getPlanPromoText(plan);
    let currSymbol = '$';
    if(currency === 'EUR') {
      currSymbol = '€';
    } else if (currency === 'GBP') {
      currSymbol = '£';
    } else if(currency === 'AUD') {
      currSymbol = 'A$';
    }

    const renderPrice = this.getPriceDisplay(origPrice)

    //CANNOT BE USED WITH PROMO / STRIPE CHECKOUT 1

    const billingInterval = this.getBillingIntervalText(plan);
    return (
      <div className="option-text">
        <div className="top-text">{promoText}</div>
        <div className="primary-text-container">
          <div className="option-subtext">
            {currSymbol}
            {renderPrice}&nbsp;{currency}
            &nbsp;{billingInterval}</div>
        </div>
      </div>
    );
  }

  renderPlanTop = (plan) => {
    const origPrice = plan.get('price');
    const currency = plan.get('currency') || 'USD';
    let currSymbol = '$';
    if(currency === 'EUR') {
      currSymbol = '€';
    } else if(currency === 'GBP') {
      currSymbol = '£';
    } else if(currency === 'AUD') {
      currSymbol = 'A$';
    }

    const activePromo = this.findValidPromoOfPlan(plan);
    const promoText = this.getPlanPromoText(plan, activePromo);

    //getPriceDisplay function determines how many digits past decimal to show
    const renderOrigPrice = this.getPriceDisplay(origPrice)

    //if plan has valid promo
    if(activePromo) {
      const promoPrice = activePromo.get('buttonPrice');
      const promoInterval = activePromo.get('buttonIntervalText');
      const renderPromoPrice = this.getPriceDisplay(promoPrice)

      return (
        <div className='option-text'>
          <div className='primary-text-container'>
            <div className='strike-thru-container'>
              <div className='top-text'>{currSymbol}{renderOrigPrice}</div>
              <div className='strike-thru-abs'></div>
            </div>
            <div className='top-text'>&nbsp;{currSymbol}{renderPromoPrice}&nbsp;{currency}</div>
            <div className='billing-cycle-text'>&nbsp;{promoInterval}</div>
          </div>
          <div className='option-subtext'>{promoText}</div>
        </div>
      )
    }

    const billingInterval = this.getBillingIntervalText(plan);
    return (
      <div className="option-text">
        <div className="primary-text-container">
          <div className="top-text">
            {currSymbol}
            {renderOrigPrice}&nbsp;{currency}
          </div>
          <div className="billing-cycle-text">&nbsp;{billingInterval}</div>
        </div>
        <div className="option-subtext">{promoText}</div>
      </div>
    );
  }

  // getPlanTopText = (plan) => {
  //   let result, price;
  //   const defaultPrice = plan.get('price') / 100;

  //   if(plan.getIn(['promo', 'buttonPrice'])){
  //     price = plan.getIn(['promo', 'buttonPrice']) / 100;
  //   } else {
  //     price = defaultPrice;
  //   }

  //   return `$${price} USD`;
  // }

  getPlanPromoText = (plan, activePromo = false) => {
    let result;
    const defaultPromoText = plan.get('promoText');

    if(activePromo) {
      const runningPromoText = activePromo.get('buttonBottomText');
      result = runningPromoText || defaultPromoText;
    } else {
      result = plan.get('promoText');
    }

    return result;
  }

  getBillingIntervalText = (plan) => {
    const billing_interval = plan.get('time_val');
    const interval_unit = plan.get('time_unit');
    const paymentType = plan.get('paymentType');
    const isLifetimePurchase = plan.get('isLifetimePurchase');

    if(paymentType && paymentType === 'one-time' && isLifetimePurchase) {
      return 'for lifetime access';
    }

    if(paymentType && paymentType === 'one-time') {
      return 'billed one-time';
    }

    if(billing_interval > 1) {
      return `every ${billing_interval} ${interval_unit}s`
    } else {
      return `per ${interval_unit}`
    }
  }

  renderPlanOptions = () => {
    const largePromoText = this.props.siteCheckout ? this.props.siteCheckout.get('largePromoText') : false;

    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions && this.props.extraPlanOptions.get(this.props.route.extraPlan)){
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    };

    if(planOptions) {
      const optionsToRender = planOptions.map((item, idx) => {
        if(!item) return null;

        const highlightBadgeText = item.get('highlightBadgeText')
        const highlightBadgeColor = item.get('highlightBadgeColor')

        const optionJSX = (
          <div
            className='option'
            key={idx}
            onClick={() => this.selectPlan(idx)}>
            {highlightBadgeText ? this.renderHighlightBadge(highlightBadgeText, highlightBadgeColor) : null}
            {largePromoText === true ? this.renderPlanTopLargePromo(item) : this.renderPlanTop(item)}
          </div>
        );

        if(idx !== 0) {
          //render with separator on top if more than 1 option
          return [<div className='separator'></div>, optionJSX];
        } else {
          //render first  or solo option with no separator on top
          return optionJSX;
        }
      });

      return optionsToRender;

    } else {
      return null;
    }
  };

  renderEnterPromo = () => {
    return (
      <div className='promo-container'>
        {this.state.showEnterPromo ?
          <div className='enter-promo-container'>
            <div className='expand-collapse-prompt'
              onClick={() => this.setState({ showEnterPromo: false })}>
              Enter promo code
              <div className='close-prompt-container'>
                <img
                  src={require('../../images/close.svg')}
                  className='close-icon'
                />
              </div>
            </div>
            <div className='apply-code-row'>
              <input
                type='text'
                className='promo-input'
                placeholder='Promo Code'
                id='promo-code'
                maxLength='254'
                onChange={event => {
                  this.setState({ couponCode: event.target.value });
                }}
                onKeyPress={(e) => { if(e.which === 13) { this.applyPromoCode() } }} //enter applies coupon
                value={this.state.couponCode}
              />
              <button
                type='button'
                className='apply-button'
                onClick={() => this.applyPromoCode() }
              >
                Apply
              </button>
            </div>
            { this.state.isUserInputCouponValid === true ?
              <div className='code-applied-status success'>
                Promo code successfully applied!
              </div>
              : null
            }
            {this.state.isUserInputCouponValid === false ?
              <div className='code-applied-status error'>
                Promo code is not valid. Please confirm you entered the correct code.
              </div>
              : null
            }
          </div>
        :
          <div className='expand-collapse-prompt'
          onClick={ () => this.setState({ showEnterPromo: true }) }>
          Have a promo code?
          <img
            src={require('../../images/dropdown.svg')}
            className='dropdown-arrow'
          />
        </div>
        }

      </div>
    )
  }

  applyPromoCode = async () => {
    const couponCode = this.state.couponCode

    //determine if is valid
    //traverse all plans
    //see if coupon exists and is valid
      //how to determine if valid? if date valid

    //if so, then setState
    //else do not and set invalid code

    const isValid = this.getIsPromoCodeValid(couponCode)

    if(isValid){
      this.setState({
        appliedCouponCode: couponCode,
        isUserInputCouponValid: true,
        selectedPlanIdx: null
      })
    } else if (this.state.coachOrgId === "-NcUDKiuheE8aswVXrqW" && couponCode) {
      const coupon = await FetchOneTimeCoupon(this.state.coachOrgId, couponCode)
      if(coupon){
        this.setState({
          appliedCouponCode: couponCode,
          isUserInputCouponValid: true,
          selectedPlanIdx: null,
          oneTimeCouponPlan: coupon,
        })
      } else {
        this.setState({
          isUserInputCouponValid: false
        })
      }
    } else {
      this.setState({
        isUserInputCouponValid: false
      })
    }
  }

  getIsPromoCodeValid = (code = '') => {
    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    };

    if(!planOptions) return false

    let isValid = false

    planOptions.forEach((plan) => {
      if(!plan || !plan.get('promo')){
        return
      }

      let promos = plan.get('promo')

      //Backwards compatibility for when plan.promo is not an array
      const isSinglePromo = promos.get('stripeCouponId') ? true : false
      if(isSinglePromo) {
        promos = Immutable.fromJS([promos])
      }

      promos.forEach(promo => {
        if(!promo) return
        const dateValid = this.getIsPromoDateValid(promo)
        const codeStd = code.trim().toLowerCase()
        const couponId = promo.get('stripeCouponId') || ''
        const couponIdStd = couponId.trim().toLowerCase()
        const promoCouponMatches = codeStd === couponIdStd

        if(dateValid && promoCouponMatches){
          isValid = true
        }
      })
    })

    return isValid
  }

  renderSelectedPlan = () => {
    const largePromoText = this.props.siteCheckout ? this.props.siteCheckout.get('largePromoText') : false;
    let planOptions = null;
    if(this.props.route.extraPlan && this.props.extraPlanOptions && this.props.extraPlanOptions.get(this.props.route.extraPlan)){
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    };
    const { selectedPlanIdx } = this.state;
    const selectedPlan = planOptions.get(selectedPlanIdx);
    const planResetVal = planOptions.size > 1 ? null : 0;

    const highlightBadgeText = selectedPlan.get('highlightBadgeText')
    const highlightBadgeColor = selectedPlan.get('highlightBadgeColor')

    const optionJSX = (
      <div
        className='option option-selected'
        onClick={() => this.selectPlan(planResetVal)}>
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'start', justifyContent: 'start'}}>
            {highlightBadgeText ? this.renderHighlightBadge(highlightBadgeText, highlightBadgeColor) : null}
            {largePromoText === true ? this.renderPlanTopLargePromo(selectedPlan) : this.renderPlanTop(selectedPlan)}
          </div>
        {planResetVal === 0 ? null : <div className='down-arrow' />}
      </div>
    );

    return optionJSX;
  };

  renderAccountSection = () => {
    if(this.state.isAuthed) {
      return (
        <div className='logged-in-email'>
          <div>Logged in as:</div>
          <div className='email'>
            {this.state.email}
            &nbsp;
          </div>
          <button
            type='button'
            className='change-login'
            onClick={() => {
              this.setState({ isAuthed: false, showSignup: false, showLogin: false }, () => {
                this.calculateActiveSection();
              });
            }}
          >
            Switch Account
          </button>
        </div>
      );
    } else {
      return [
        <div className='account-subcontainer'>{this.renderSignup()}</div>,
        <div className='separator-width'>{this.renderSeparator()}</div>,
        <div className='account-subcontainer'>{this.renderLogin()}</div>
      ];
    }
  };

  renderSeparator = () => {
    return (
      <div className='separator-container'>
        <div className='half-horiz-line' />
        <div className='or-text'>OR</div>
        <div className='half-horiz-line' />
      </div>
    )
  }

  goToForgotPassword = () => {
    const forgotURL = `/forgotpassword`
    this.props.history.push({pathname: forgotURL, state: {allowBack: true}})
  }

  renderLogin = () => {
    if(this.state.showLogin) {
      const loader = (<div className='loader' />);

      return [
        <div className='login-form'>
          <input
            type='text'
            className='account-input'
            placeholder='E-mail'
            id='login-email'
            maxLength='254'
            onChange={event => {
              this.setState({ email: event.target.value });
            }}
            value={this.state.email}
          />
          <input
            type='password'
            className='account-input'
            placeholder='Password'
            id='login-pw'
            maxLength='128'
            onChange={event => {
              this.setState({ password: event.target.value });
            }}
            onKeyPress={(e) => { if(e.which === 13) { this.onClickLogin() } }} //Allows enter key to submit
            value={this.state.password}
          />
          <button
            type='button'
            className='finish-login-button'
            onClick={() => { this.onClickLogin(); }}
          >
            {this.state.authLoading ? loader : 'Login'}
          </button>
          <div className='forgot-password-text' onClick={this.goToForgotPassword}>Forgot password?</div>
        </div>
      ];
    } else {
      return (
        <button
          type='button'
          className='login-button'
          onClick={() => {
            this.setState({
              showLogin: true,
              showSignup: false,
              password: '',
              loginError: false,
              pwError: false,
              emailError: false,
              loginErrorDesc: '',
            });
          }}
        >
          Log in
        </button>
      );
    }
  };

  renderSignup = () => {
    if(this.state.showSignup) {
      const loader = (<div className='loader' />);
      const waiverUrl = `https://trybe.do/waiver?coachOrgId=${this.state.coachOrgId}`;


      return (
        <div className='signup-form'>
          <input
            type='text'
            className='account-input'
            placeholder='First name'
            id='firstName'
            maxLength='50'
            onChange={event => {
              this.setState({ firstName: event.target.value });
            }}
            value={this.state.firstName}
          />
          <input
            type='text'
            className='account-input'
            placeholder='Last name'
            id='lastName'
            maxLength='50'
            onChange={event => {
              this.setState({ lastName: event.target.value });
            }}
            value={this.state.lastName}
          />
          <input
            type='text'
            className='account-input'
            placeholder='E-mail'
            id='email'
            maxLength='254'//Recommended max length for emails
            onChange={event => {
              this.setState({ email: event.target.value });
            }}
            value={this.state.email}
          />
          <input
            type='password'
            className='account-input'
            placeholder='Password'
            id='pw'
            maxLength='128'//Recommended max length for password
            onChange={event => {
              this.setState({ password: event.target.value });
            }}
            onKeyPress={(e) => { if(e.which === 13) { this.onClickSignup() } }} //Allows enter key submit
            value={this.state.password}
          />
          {SHOW_GDPR ?
            <div className='gdpr-check'>
              <div className='gdpr-prompt'>
                <div className='checkbox-container' onClick={() => this.setState({ emailConsent: !this.state.emailConsent })}>
                  {this.state.emailConsent ? <div className='checkmark' /> : null}
                </div>
                <div className='prompt-text'>{EMAIL_CONSENT_PROMPT}</div>
              </div>
            </div>
            : null
          }

          {this.state.agreementsChecked ?
            <button
              type='button'
              className='finish-signup-button'
              onClick={this.onClickSignup}>
              {this.state.authLoading ? loader : 'Create account'}
            </button>
            :
            <div
              className='finish-signup-button button-disabled'>
              {this.state.authLoading ? loader : 'Create account'}
            </div>
          }

          <div className='policies-and-terms'>
            <div
              className={this.state.agreementsChecked ? 'checkbox checkbox-agreed' : 'checkbox'}
              onClick={this.onClickAgreementsCheck}>
              {this.state.agreementsChecked ?
                <img src={require('../../images/checkmarkWhite.png')} className='checkmark' />
                : null
              }
            </div>
            <div className='terms-text-container'>
              <div className='terms-text'>
                I agree to the&nbsp;
                <a className='terms-' href='https://www.iubenda.com/privacy-policy/7826759' target='_blank'>privacy policy</a>
                ,&nbsp;
                <a href='https://trybe.do/terms' target='_blank'>terms</a>
                ,&nbsp;and&nbsp;
                <a href={waiverUrl} target='_blank'>waiver</a>.
              </div>
            </div>
          </div>
          <div>
            {this.state.errors}
          </div>
        </div>
      );
    } else {
      return (
        <button
          type='button'
          className='signup-button'
          onClick={() => {
            this.setState({
              showSignup: true,
              showLogin: false,
              password: '',
              loginError: false,
              pwError: false,
              emailError: false,
              loginErrorDesc: '',
            });
          }}
        >
          Sign up
        </button>
      );
    }
  };

  renderErrors = () => {
    const emailErrorText = `Invalid email address`;
    const pwErrorText = `Password must be at least 6 characters long`;
    const loginErrorText = `` + this.state.loginErrorDesc

    return (
      <div className='login-errors'>
        <div className='error-text'> {this.state.emailError ? emailErrorText : null} </div>
        <div className='error-text'> {this.state.pwError ? pwErrorText : null} </div>
        <div className='error-text'> {this.state.loginError ? loginErrorText : null} </div>
      </div>
    )
  }

  renderPayButton = () => {
    const { paymentLoading } = this.state;
    const text = 'Pay';
    const payText = (<div className='pay-button-text'>{text}</div>);
    const loader = (<div className='loader' />);

      return (
        <button type='button' className='pay-button' onClick={this.onClickPay}>
          {paymentLoading ? loader : payText}
        </button>
      );
  };

  renderPaymentError = () => {
    const paymentError = this.state.paymentError;
    if(!paymentError || paymentError === '') return null

    return (
      <div className='payment-errors'>
        <div className='error-text'> {paymentError} </div>
      </div>
    );
  }

  renderPayPalHint = () => {
    const { showPayPalHint } = this.state;
    const { payPalBackupMessage } = this.props

    if(payPalBackupMessage){
      return(
        <div>
          <button
            onClick={() => this.setState({ showPayPalHint: !showPayPalHint })}
            className='paypal-hint-button'
          >
            Don’t have a credit card?
          </button>
          {showPayPalHint && (
            <p className='paypal-hint-text'>
              {payPalBackupMessage || 'Email support@trybe.do to pay using PayPal for a 6 month or 1 year membership'}
            </p>
          )}
        </div>
      )
    } else {
      return null
    }
  };

  renderHeroText = () => {
    const checkoutHeroText = this.props.siteCheckout ? this.props.siteCheckout.getIn(["heroSection", "mainText"]) : null;
    const productName = this.props.productName;
    const displayedText = checkoutHeroText || productName

    if (!displayedText) {
      return null;
    }

    return <div className="hero-image-text">{displayedText}</div>;
  };

  renderHeroSubtitle = () => {
    const subtitle = this.props.siteCheckout ? this.props.siteCheckout.get('heroSubtitle') : null;

    if(!subtitle) {
      return null;
    }

    return (
      <div className='hero-image-subtitle'>{subtitle}</div>
    )
  }

  renderBenefits = () => {
    let benefits = null;

    if(this.props.route.extraPlan){
      benefits = this.props.extraBenefits ? this.props.extraBenefits.get(this.props.route.extraPlan) : null;
    } else {
      benefits = this.props.siteCheckout ? this.props.siteCheckout.get('benefits') : null;
    }

    if(benefits && benefits.size > 0) {
      const benefitsJSX = benefits.map((benefit, idx) => {
        return (
          <div className='benefit-row' key={idx}>
            <div className='benefit-checkmark' />
            <div className='benefit-text'>{benefit}</div>
          </div>
        )
      })

      return (
        <div className='benefits-box benefits-box--payments'>
          <div className='benefits-header'> What you get </div>
          {benefitsJSX}
        </div>
      )
    } else {
      return null;
    }
  }

  renderHeroSection = () => {
    const heroImgUrl = this.props.siteCheckout ?
      this.props.siteCheckout.get('heroImage')
      : null;

    const deepLink = this.props.siteCheckout ?
      this.props.siteCheckout.get('deepLink')
      : null;

    return (
      <div className='hero-image' style={{
        backgroundImage: `url(${heroImgUrl})`
      }}>
        <div className='hero-image-overlay' />
        {this.renderHeroText()}
        {this.renderHeroSubtitle()}
        {deepLink ?
          <div className='app-stores-row'>
            <img src={require('../../images/appStore.svg')} className='app-store-img' onClick={this.onClickApp} />
            <img src={require('../../images/googlePlay.svg')} className='google-play-img' onClick={this.onClickApp} />
          </div>
          : null
        }
      </div>
    )
  }

  renderHeader = () => {
    let sectionsClass = 'navbar-section';
    if(this.props.route.navBarColor === 'trybe-black') {
      sectionsClass = 'navbar-section-black'
    }

    return (
      <div className={sectionsClass}>
        <div className='navbar-content'>
          <div className='logo-container' onClick={() => { window.location.href = 'https://trybe.fit' }}>
            <img className='logo-img' src={require('../../images/trybe-logo-white.svg')} />
            <div className='logo-text'>TRYBE</div>
          </div>
        </div>
      </div>
    )
  }

  renderBrandedHeader = () => {
    let sectionsClass = 'navbar-section';
    let redirectUrl = 'https://trybe.fit';
    let logo = null;

    if(this.props.route.navBarColor === 'trybe-black') {
      sectionsClass = 'navbar-section-black'
    }

    if(this.props.landingPageCustomizations){
      if(this.props.landingPageCustomizations.getIn(['header', 'redirectUrl'])) {
        redirectUrl = this.props.landingPageCustomizations.getIn(['header', 'redirectUrl']);
      }

      if(this.props.landingPageCustomizations.getIn(['header', 'logo'])){
        logo = this.props.landingPageCustomizations.getIn(['header', 'logo']);
      }
    }

    return (
      <div className={sectionsClass}>
        <div className='navbar-content'>
          <div className='logo-container' onClick={() => { window.location.href = redirectUrl}}>
            <img className='coach-custom-logo' src={logo} />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      selectedPlanIdx,
      activeSection,
      shouldSkipAuth,
      benefitsShowing,
      isAuthed,
      pwError,
      emailError,
      loginError,
      isCheckingRedirect,
    } = this.state;

    if(isCheckingRedirect) {
      return null;
    }

    return (
      <div className='coach-checkout-container'>
        {this.props.route.useBrandedHeader ?  this.renderBrandedHeader() : this.renderHeader()}

        {this.state.shouldSurvey ? this.renderSurvey() :
        <div className='main-body-container'>
          {this.renderHeroSection()}
          <div className='main-body'>
            <div className='payments-flow'>
              {this.props.route.useBrandedHeader ? null : this.renderLogo()}
              <div className='section-container'>
                <div className={activeSection === 0 ? 'section-header-active' : 'section-header-inactive'}>
                  <div
                    className={selectedPlanIdx || selectedPlanIdx === 0 ? 'section-checkmark' : null}
                  />
                  1. Select your plan &nbsp;
                </div>
                <div className={activeSection === 0 ? 'plan-selection-active' : 'plan-selection-inactive'}>
                  <div className='plan-radio-options'>
                    {!(selectedPlanIdx || selectedPlanIdx === 0)
                      ? this.renderPlanOptions()
                      : this.renderSelectedPlan()}
                    {this.renderEnterPromo()}
                  </div>
                </div>
                {this.renderBenefits()}
              </div>

              {shouldSkipAuth ?
                null
                :
                <div className={benefitsShowing ? 'section-container section-container-adj-top' : 'section-container'}>
                  <div className={activeSection === 1 ? 'section-header-active' : 'section-header-inactive'}>
                    <div className={isAuthed ? 'section-checkmark' : null} />
                    2. Create an account
                  </div>
                  <div className={activeSection === 1 ? 'create-account-active' : 'create-account-inactive'}>
                    {this.renderAccountSection()}
                    {(pwError || emailError || loginError) ? this.renderErrors() : null}
                  </div>
                </div>
              }

              <div className='section-container section-container-last'>
                <div className={activeSection === 2 ? 'section-header-active' : 'section-header-inactive'}>
                  {shouldSkipAuth ?
                    '2. Enter billing info'
                    :
                    '3. Enter billing info'
                  }
                </div>
                <div className='payment-method'>
                  {this.renderPayButton()}
                  {this.renderPaymentError()}
                  {this.renderPayPalHint()}
                </div>
              </div>
            </div>
          </div>
        </div>
        }

      </div>
    );
  }

  getCheckoutSuccessUrl = (price, discountedPrice) => {
    let urlParams = window.location.search.substring(1);

    //if creator wants us to redirect to a custom URL, ie. customCheckoutSuccessURL is set, then
    //skip all Google Analytics logic and instead send to creator's URL
    if(this.props.customCheckoutSuccessURL){
      let checkoutURL = this.props.customCheckoutSuccessURL;

      if(urlParams){
        urlParams += '&';
      }

      if(discountedPrice || price){
        urlParams += `priceLabel=${discountedPrice || price}`
      }

      return `${checkoutURL}?${urlParams}`;
    }

    const { selectedPlanIdx } = this.state;
    const gaPlanLabel = this.getGAPlanLabel(selectedPlanIdx);

    if(urlParams){
      urlParams += '&';
    }

    urlParams += `coachOrgId=${this.state.coachOrgId}&gaPlanLabel=${gaPlanLabel}&priceLabel=${discountedPrice || price}`;

    const domain = config.dbEnv === 'dev' ?
      'http://localhost:8000/webpack-dev-server'
      : 'https://trybe.do';

    return `${domain}/site_checkout_success?${urlParams}`;
  }

  /*
  Returns valid PROMO object to render using the following order of operations:
  1. Check for coupon in URL
  2. Return first coupon in Promo Array to match first valid coupon in URL params. Must be active based on start/expire dates
  3. Else return first autoApplied promo that is active based on start/expire dates
  For backwards compatibility, checks if promos is an array using promo.get('stripeCouponId') which will assume its not an array of promos but a single promo
  */
  findValidPromoOfPlan = (plan, unixBuffer = 0) => {
    if(!plan) {
      return false;
    }

    let promos = plan.get('promo');
    if(!promos) {
      return false;
    }

    //Backwards compatibility for when plan.promo is not an array
    const isSinglePromo = promos.get('stripeCouponId') ? true : false
    if(isSinglePromo) {
      promos = Immutable.fromJS([promos])
    }

    let coupons = null;

    //If user typed their own code, that takes precedence
    const userInputtedCoupon = this.state.appliedCouponCode;

    //Generates a comma separated string of couponIds in URL
    const urlCoupons = getURLVal('coupon');

    if(userInputtedCoupon){
      coupons = userInputtedCoupon;
    } else if(Array.isArray(urlCoupons)) {
      //else if URL has multiple coupons, use those
      coupons = urlCoupons.join();
    } else {
      //single coupon from URL
      coupons = urlCoupons;
    }

    //Temp feetup code
    if (this.state.coachOrgId === "-NcUDKiuheE8aswVXrqW" && plan.get('time_unit') === "year" && this.state.oneTimeCouponPlan && userInputtedCoupon) {
      return Immutable.fromJS(this.state.oneTimeCouponPlan)
    }
    //End temp code

    //If valid coupon exists in URL or promo input, return that promo first
    if(coupons) {
      const validPromosOfCoupon = promos.filter((promo, idx) => {
        if(!promo) return
        const dateValid = this.getIsPromoDateValid(promo)

        const couponsStd = coupons.trim().toLowerCase()
        const couponId = promo.get('stripeCouponId') || ''
        const couponIdStd = couponId.trim().toLowerCase()
        const promoCouponMatches = couponsStd === couponIdStd
        const valid = dateValid && promoCouponMatches;
        return valid
      })

      if(!validPromosOfCoupon.isEmpty()) {
        const validPromo = validPromosOfCoupon.first();
        return validPromo
      }
    }

    //If auto apply coupons exist, return that promo
    const validAutoApplyPromos = promos.filter((promo, idx) => {
      if(!promo) return
      const dateValid = this.getIsPromoDateValid(promo)
      const isAutoApplied = promo.get('isAutoApplied');
      const valid = dateValid && isAutoApplied;
      return valid
    })

    if(!validAutoApplyPromos.isEmpty()) {
      const validAutoApplyPromo = validAutoApplyPromos.first();
      return validAutoApplyPromo
    }


    return false;
  }

  getIsPromoDateValid = (promoOfPlan, unixBuffer = 0) => {
    const now = new Date().getTime();
    const expiration = promoOfPlan.get('expiration');
    const bufferedExpiration = expiration + unixBuffer;
    const startDate = promoOfPlan.get('startDate')
    const dateValid = now > startDate && now < bufferedExpiration;
    return dateValid
  }
}

export default CoachCheckout;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/CoachCheckout.js